import { OfferList } from '../../components'
import { ReactElement } from 'react'
import { Button, Container, ScrollView, Spinner, Stack, YStack, isWeb } from '@my/ui'
import { MainLayout, Meta, SectionTitle } from 'app/components'
import { DiscountsHomeOffersQueryOutput, DiscountsHomeQueryOutput } from './queries'
import { OfferBlockRenderer } from '../../blocks'
import { CategoryTabs } from '../../containers'
import { RefreshControl } from 'react-native'

export interface OffersScreenProps {
  loading: boolean
  content: DiscountsHomeQueryOutput['DiscountsHome']['content']
  offers: DiscountsHomeOffersQueryOutput['fetchOffers']['docs']
  meta?: DiscountsHomeQueryOutput['DiscountsHome']['meta']
  error: any
  hasMore: boolean
  loadingMore: boolean
  onLoadMore: () => void
  HeaderComponent?: ReactElement

  refreshing: boolean
  onPullToRefresh: () => void
}

export const OffersScreen = (props: OffersScreenProps) => {
  return (
    <MainLayout>
      <Meta title={props.meta?.title || "Student Saviour"} description={props.meta?.description} />
      {isWeb && <CategoryTabs />}
      <ScrollView
        refreshControl={
          <RefreshControl refreshing={props.refreshing} onRefresh={props.onPullToRefresh} />
        }
      >
        <Container
          gap="$6"
          flex={1}
          alignItems="center"
          spaceTop
          spaceBottom
          justifyContent="center"
        >
          <Stack flexShrink={1} w="100%" h="100%" gap="$6">
            {props.loading ? (
              <YStack>
                <Spinner size="large" />
              </YStack>
            ) : (
              <OfferBlockRenderer
                content={props.content.filter((item) => item.blockType !== 'categoryTabs')} //filter categoryTabs out o as it has fixed position and will be separately rendered
              />
            )}

            {props.offers.length > 0 && (
              <Container size="base" gutter>
                <YStack flex={1} width="100%">
                  <SectionTitle pb="$3.5">
                    More Deals
                  </SectionTitle>
                  <OfferList items={props.offers} />
                  {props.hasMore && (
                    <Button
                      theme="primary"
                      maxWidth={500}
                      mt="$6"
                      w="100%"
                      mx="auto"
                      loading={props.loadingMore}
                      onPress={props.onLoadMore}
                    >
                      Load more
                    </Button>
                  )}
                </YStack>
              </Container>
            )}
          </Stack>
        </Container>
      </ScrollView>
    </MainLayout>
  )
}
